// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3LM3q","tab":"Tabs_tab__3eU9Q","tabActive":"Tabs_tabActive__2XSEr"};